var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-component',{attrs:{"active":_vm.active,"titleModal":_vm.item.name,"disabled":_vm.loading,"loader":_vm.loading,"isMessage":true,"actionCenter":true,"widthModal":"width: 70%"},on:{"cancel":_vm.close}},[_c('div',{staticClass:"has-text-confirmation",domProps:{"innerHTML":_vm._s(_vm.item.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }